import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=f80d18c4&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=js&"
export * from "./UserTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=f80d18c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80d18c4",
  null
  
)

export default component.exports